module.exports = __webpack_public_path__ + "img/subscribed.b013fa2d.png";